import moment from "moment";
import {
  SALES_REPORT_EXPORT_NAMES,
  useSalesReportExportMutation,
} from "../../../../../../../../api/mutations/useSalesReportExportMutation";
import {
  API_DATE_FORMAT,
  FILE_EXPORT_TYPES,
} from "../../../../../../../../consts/api";
import { useAppTranslation } from "../../../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../../../services/UINotificationService";
import { composeDownloadDataUrl } from "../../../../../../../../utilities/api";

export function useDownloadExcel({ period, clinic }) {
  const { tCommon } = useAppTranslation.Common();

  const { mutateAsync, isLoading } = useSalesReportExportMutation({
    onError: () => {
      uiNotification.error(tCommon("error.exportXlsReports"));
    },
  });

  const initiate = async () => {
    const res = await mutateAsync({
      rawPayload: {
        fromDate: moment(period.value.from).format(API_DATE_FORMAT),
        toDate: moment(period.value.to).format(API_DATE_FORMAT),
        clinic_id: clinic.value,
      },
      type: FILE_EXPORT_TYPES.xls,
      name: SALES_REPORT_EXPORT_NAMES.expiredLiabilityReport,
    });

    window.open(composeDownloadDataUrl(res.fileName), "_blank");
  };

  return {
    initiate,
    isLoading,
  };
}
